export const TOKEN_CHECK_INTERVAL_TIME : number = 60000;
export const USER_INACTIVITY_MAX_TIME : number = 600000;
